import{Subject as r}from"rxjs";export var isSubjectProxyObservableConfig=function(e){return void 0===e.EmitterEngine||e.EmitterEngine===r};